export const SOCIAL_OVERVIEW_SINGLE_BRAND = [
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 0,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['FOLLOWER_GROWTH_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 0,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['FOLLOWER_GROWTH_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 0,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['FOLLOWER_GROWTH_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 0,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['FOLLOWER_GROWTH_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 0,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['FOLLOWER_GROWTH_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 0,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['SUBSCRIBER_GROWTH_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 2,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 2,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 2,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['AVG_ENGAGEMENT_RATE_V2'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 2,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 2,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 2,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['AVG_ENGAGEMENT_RATE_ALL_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 4,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TSI_CHANNELS'],
      metrics: ['TOTAL_TSI'],
      static_dates: {
        start_date: '2020-10-22',
        end_date: '2025-10-22',
        rolling_time: true,
      },
    },
  },
  {
    h: 4,
    type: 'DOUGHNUT_METRIC',
    w: 3,
    x: 3,
    y: 4,
    meta: {
      brand_ids: ['brand_ids'],
      channels: [
        'TIKTOK',
        'INSTAGRAM',
        'FACEBOOK',
        'PINTEREST',
        'TWITTER',
        'YOUTUBE',
        'LINKEDIN',
        'INSTAGRAM_UGC',
        'INSTAGRAM_STORIES',
        'TIKTOK_UGC',
      ],
      metrics: ['TOTAL_TSI'],
      aggregate_by: 'CHANNEL',
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 8,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'PINTEREST', 'TWITTER', 'YOUTUBE', 'LINKEDIN'],
      metrics: ['NET_NEW_FOLLOWERS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 8,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'INSTAGRAM', 'FACEBOOK', 'PINTEREST', 'TWITTER', 'LINKEDIN'],
      metrics: ['AVG_ENGAGEMENT_RATE_V3'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 12,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK', 'PINTEREST', 'YOUTUBE'],
      metrics: ['TOTAL_VIDEO_VIEWS_V2'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 12,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK', 'INSTAGRAM', 'TWITTER', 'LINKEDIN'],
      metrics: ['ORGANIC_VIDEO_VIEWS_V2'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 16,
    meta: {
      name: 'TikTok Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['NUMBER_OF_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['AVG_REACH'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['AVG_VIDEO_VIEWS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['AVG_RETENTION_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 17,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metrics: ['AVG_ENTERTAINMENT_SCORE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 19,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metric: 'TOTAL_ENGAGEMENTS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 19,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metric: 'TOTAL_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 23,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 23,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TIKTOK'],
      metric: 'VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 27,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'ENTERTAINMENT_SCORE',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 31,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TIKTOK',
      metric: 'TOTAL_VIDEO_VIEWS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },

  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 35,
    meta: {
      name: 'Instagram Feed Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 36,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['NUMBER_OF_POSTS_ORGANIC'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 36,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 36,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['AVG_EFFECTIVENESS_ENGAGEMENTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 36,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['AVG_REACH'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 36,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['VIEWS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 36,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['LIKESHOP_CLICKS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 38,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['TOTAL_ENGAGEMENTS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 38,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metrics: ['VIEWS_VIDEO_REEL', 'VIEWS_VIDEO', 'VIEWS_REEL'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 42,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'MULTI_METRIC_MEDIA_TYPE',
    w: 3,
    x: 3,
    y: 42,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'INSTAGRAM',
      metrics: [
        'NUMBER_OF_POSTS_ORGANIC_VIDEO',
        'NUMBER_OF_POSTS_ORGANIC_REEL',
        'NUMBER_OF_POSTS_ORGANIC_PHOTO',
        'NUMBER_OF_POSTS_ORGANIC_CAROUSEL',
      ],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 46,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'INSTAGRAM',
      metric: 'ENGAGEMENT_RATE',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 50,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'INSTAGRAM',
      metric: 'VIEWS_VIDEO_REEL',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 54,
    meta: {
      name: 'Instagram Story Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 55,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metrics: ['NUMBER_OF_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 55,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metrics: ['AVG_REACH'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 55,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metrics: ['VIEWS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 55,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metrics: ['AVG_COMPLETION_RATE_VIEWS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 55,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metrics: ['AVG_EXIT_RATE_VIEWS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 55,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metrics: ['SWIPE_UPS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 57,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metric: 'VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 57,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['INSTAGRAM_STORIES'],
      metric: 'AVG_COMPLETION_RATE_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 61,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'INSTAGRAM_STORIES',
      metric: 'SWIPE_UPS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 65,
    meta: {
      name: 'Facebook Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 66,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['NUMBER_OF_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 66,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['AVG_ENGAGEMENT_RATE_V2'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 66,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['AVG_EFFECTIVENESS_V2'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 66,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['AVG_PAID_AND_ORGANIC_POST_REACH_V2'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 66,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['PAGE_VIEWS_PAID_AND_ORGANIC'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 66,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metrics: ['LINK_CLICKS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 68,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metric: 'TOTAL_ENGAGEMENTS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 68,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metric: 'PAID_AND_ORGANIC_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 72,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 72,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['FACEBOOK'],
      metric: 'PAGE_VIEWS_PAID_AND_ORGANIC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 76,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'FACEBOOK',
      metric: 'ENGAGEMENT_RATE_V2',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 80,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'FACEBOOK',
      metric: 'VIDEO_VIEWS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 84,
    meta: {
      name: 'Pinterest Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 85,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['NUMBER_OF_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 85,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 85,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['IMPRESSIONS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 85,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['SAVES'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 85,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['CLOSEUPS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 85,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metrics: ['LINK_CLICKS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 87,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 87,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metric: 'IMPRESSIONS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 91,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metric: 'SAVES',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 91,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['PINTEREST'],
      metric: 'LINK_CLICKS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 95,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'PINTEREST',
      metric: 'ENGAGEMENT_RATE',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 99,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'PINTEREST',
      metric: 'TOTAL_VIDEO_VIEWS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 103,
    meta: {
      name: 'X Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 104,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['NUMBER_OF_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 104,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['AVG_ENGAGEMENT_RATE'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 104,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['IMPRESSIONS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 104,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['RETWEETS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 104,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['REPLIES'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 104,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metrics: ['LINK_CLICKS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 106,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metric: 'TOTAL_ENGAGEMENTS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 106,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metric: 'ORGANIC_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 110,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 110,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['TWITTER'],
      metric: 'IMPRESSIONS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 114,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TWITTER',
      metric: 'ENGAGEMENT_RATE',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT',
    w: 6,
    x: 0,
    y: 118,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'TWITTER',
      metric: 'VIDEO_VIEWS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 122,
    meta: {
      name: 'YouTube Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 123,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['NUMBER_OF_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 123,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['TOTAL_AVG_VIEW_DURATION'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 123,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['TOTAL_ENGAGEMENTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 123,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['TOTAL_LIKES'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 123,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['TOTAL_ESTIMATED_SECONDS_WATCHED'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 123,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['TOTAL_VIDEO_VIEWS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 125,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['TOTAL_ENGAGEMENTS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 125,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['TOTAL_VIDEO_VIEWS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 129,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['SUBSCRIBERS_NET_NEW'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 129,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['YOUTUBE'],
      metrics: ['VIEWS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 133,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_ENGAGEMENTS'],
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 137,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'YOUTUBE',
      metrics: ['TOTAL_VIDEO_VIEWS'],
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 141,
    meta: {
      name: 'LinkedIn Performance',
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 142,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['NUMBER_OF_POSTS'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 142,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['AVG_ENGAGEMENT_RATE_BY_POST'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 142,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['IMPRESSIONS_BY_POST'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 142,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['CLICKS_BY_POST'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 142,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['REACTIONS_BY_POST'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 2,
    type: 'TOTAL_METRIC',
    w: 1,
    x: 5,
    y: 142,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['SHARES_BY_POST'],
      aggregate_by: 'TOTAL',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 144,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['PAGE_VIEWS_ALL_POSTS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 144,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['NET_NEW_FOLLOWERS'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 148,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['ENGAGEMENTS_BY_POST'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 148,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['IMPRESSIONS_BY_POST'],
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 152,
    meta: {
      brand_ids: ['brand_ids'],
      channel: 'LINKEDIN',
      metrics: ['ENGAGEMENT_RATE'],
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 156,
    meta: {
      brand_ids: ['brand_ids'],
      channels: ['LINKEDIN'],
      metrics: ['CLICK_THROUGH_RATE_BY_POST'],
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
];
